import { Download, EllipsisVertical, Eye } from "lucide-react";
import React, { SetStateAction } from "react";
import { Dropdown } from "react-bootstrap";

const DropDownToggle = ({
  openDropdownId,
  handleDropdownToggle,
  id,
  setActiveId,
  openDownloadModal,
  setOpenDetailsId
}: {
  openDropdownId: string | null;
  handleDropdownToggle: (isOpen: boolean, meta: any, id: string) => void;
  id: string;
  setActiveId: React.Dispatch<SetStateAction<string>>;
  setOpenDetailsId: React.Dispatch<SetStateAction<string | null>>;
  openDownloadModal: () => void;
}) => {

  return (
    <Dropdown
      className="ap-show-more"
      show={openDropdownId === id} 
      onToggle={(nextShow, meta) => handleDropdownToggle(nextShow, meta, id)}
    >
      <Dropdown.Toggle id="showMore" variant="outline" className="toggle-btn">
        <span className="">
          <EllipsisVertical color="#5C5C5C" size={16} />
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu className="toggle-tray">
        <Dropdown.Item className="item"
        onClick={() => setOpenDetailsId(id)}
        >
          <Eye color="#292929" size={16} />
          <span className="fw-normal">View Details</span>
        </Dropdown.Item>
        <Dropdown.Item
          className="item"
          onClick={() => {
            openDownloadModal();
            setActiveId(id);
          }}
        >
          <Download color="#292929" size={16} />
          <span className="fw-normal">Download</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DropDownToggle;
